import React from 'react';

const EsFlag = ({ className }) => (
  <svg viewBox="0 0 24 16" className={className} aria-hidden="true" focusable="false">
    <rect width="24" height="16" fill="#AA151B" />
    <rect y="4" width="24" height="8" fill="#F1BF00" />
  </svg>
);

export default EsFlag;
